import styled from "@emotion/styled";

export const SlideOutContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
`;

export const Header = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding: 24px 24px 16px;
  border-bottom: 1px solid #E5E7EB;
`;

export const Title = styled.h2`
  font-size: 20px;
  font-weight: 600;
  color: #111827;
  margin: 0;
  flex: 1;
  padding-right: 16px;
`;

export const CloseButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border: none;
  background: transparent;
  border-radius: 6px;
  cursor: pointer;
  color: #6B7280;
  flex-shrink: 0;

  &:hover {
    background: #F3F4F6;
    color: #111827;
  }
`;

export const ActionsRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 16px 24px;
  border-bottom: 1px solid #E5E7EB;
`;

export const ActionButton = styled.button`
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 14px;
  border: 1px solid #E5E7EB;
  background: #FFFFFF;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  color: #374151;
  cursor: pointer;
  transition: all 0.15s ease;

  &:hover {
    background: #F9FAFB;
    border-color: #D1D5DB;
  }
`;

export const ActionIconButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border: 1px solid #E5E7EB;
  background: #FFFFFF;
  border-radius: 6px;
  cursor: pointer;
  color: ${(props) => props.$danger ? '#DC2626' : '#6B7280'};
  margin-left: ${(props) => props.$marginLeft ? 'auto' : '0'};
  flex-shrink: 0;

  &:hover {
    background: ${(props) => props.$danger ? '#FEF2F2' : '#F3F4F6'};
    border-color: ${(props) => props.$danger ? '#FECACA' : '#D1D5DB'};
  }
`;

export const ContentArea = styled.div`
  flex: 1;
  overflow-y: auto;
  padding: 0;
`;

export const Section = styled.div`
  padding: 20px 24px;
  border-bottom: 1px solid #F3F4F6;

  &:last-child {
    border-bottom: none;
  }
`;

export const SectionHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: ${(props) => props.$noMargin ? '0' : '12px'};
`;

export const SectionTitle = styled.h3`
  font-size: 14px;
  font-weight: 600;
  color: #111827;
  margin: 0;
`;

export const SectionCount = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 24px;
  height: 24px;
  padding: 0 8px;
  background: #F3F4F6;
  border-radius: 12px;
  font-size: 13px;
  font-weight: 500;
  color: #374151;
`;

export const DescriptionText = styled.p`
  font-size: 14px;
  line-height: 1.6;
  color: #374151;
  margin: 0;
`;

export const DetailsGrid = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const DetailRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const DetailLabel = styled.span`
  font-size: 14px;
  color: #6B7280;
`;

export const DetailValue = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const CategoryBadge = styled.span`
  display: inline-flex;
  align-items: center;
  padding: 4px 12px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  background: ${(props) => props.$bgColor || '#D1FAE5'};
  color: ${(props) => props.$color || '#059669'};
`;

export const StatusBadge = styled.span`
  display: inline-flex;
  align-items: center;
  padding: 4px 12px;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 500;
  background: #1E293B;
  color: #FFFFFF;
`;

export const VisibilityValue = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 14px;
  color: #374151;
`;

export const AuthorValue = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const AuthorAvatar = styled.div`
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: #E5E7EB;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

export const AuthorName = styled.span`
  font-size: 14px;
  font-weight: 500;
  color: #111827;
`;

export const AuthorTimestamp = styled.span`
  font-size: 13px;
  color: #6B7280;
  margin-left: 8px;
`;

export const AuthorSeparator = styled.span`
  font-size: 13px;
  color: #D1D5DB;
  margin: 0 6px;
`;

export const TagsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
`;

export const Tag = styled.span`
  display: inline-flex;
  align-items: center;
  padding: 4px 12px;
  border: 1px solid #E5E7EB;
  border-radius: 6px;
  font-size: 13px;
  color: #374151;
  background: #FFFFFF;
`;

export const TimelineList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const TimelineItem = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 12px;
`;

export const TimelineIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  color: #9CA3AF;
  flex-shrink: 0;
  margin-top: 2px;
`;

export const TimelineContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

export const TimelineLabel = styled.span`
  font-size: 14px;
  font-weight: 500;
  color: #111827;
`;

export const TimelineDate = styled.span`
  font-size: 13px;
  color: #6B7280;
`;

export const AttachmentsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const AttachmentItem = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px;
  background: #F9FAFB;
  border-radius: 8px;
`;

export const AttachmentIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  background: #FFFFFF;
  border: 1px solid #E5E7EB;
  border-radius: 8px;
  color: #6B7280;
`;

export const AttachmentInfo = styled.div`
  flex: 1;
  min-width: 0;
`;

export const AttachmentName = styled.div`
  font-size: 14px;
  font-weight: 500;
  color: #111827;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const AttachmentSize = styled.div`
  font-size: 12px;
  color: #6B7280;
`;

export const LinkedEntitiesList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const LinkedEntityItem = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 16px;
  border: 1px solid #E5E7EB;
  border-radius: 8px;
`;

export const LinkedEntityIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  color: #6B7280;
`;

export const LinkedEntityInfo = styled.div`
  flex: 1;
  min-width: 0;
`;

export const LinkedEntityName = styled.div`
  font-size: 14px;
  font-weight: 500;
  color: #111827;
`;

export const LinkedEntityMeta = styled.div`
  font-size: 13px;
  color: #6B7280;
`;

export const LinkedEntityAction = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border: 1px solid #E5E7EB;
  background: #FFFFFF;
  border-radius: 50%;
  cursor: pointer;
  color: #6B7280;

  &:hover {
    background: #F9FAFB;
  }
`;

export const EmptyState = styled.div`
  padding: 24px;
  text-align: center;
  color: #9CA3AF;
  font-size: 14px;
`;

// Form styles for create/edit mode
export const FormContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 24px;
`;

export const FormSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const FormLabel = styled.label`
  font-size: 14px;
  font-weight: 500;
  color: #374151;
`;

export const FormRow = styled.div`
  display: flex;
  gap: 16px;
`;

export const FormField = styled.div`
  flex: 1;
`;

export const ErrorMessage = styled.div`
  padding: 12px 16px;
  background: #FEF2F2;
  border: 1px solid #FECACA;
  border-radius: 8px;
  color: #DC2626;
  font-size: 14px;
`;

// Inline editing styles
export const EditableTitle = styled.div`
  flex: 1;
  padding-right: 16px;
  
  input {
    width: 100%;
    font-size: 20px;
    font-weight: 600;
    color: #111827;
    border: 1px solid #D1D5DB;
    border-radius: 6px;
    padding: 8px 12px;
    outline: none;
    
    &:focus {
      border-color: #155DFC;
      box-shadow: 0 0 0 2px rgba(21, 93, 252, 0.1);
    }
  }
`;

export const InlineEditorWrapper = styled.div`
  margin-top: 8px;
  border: 1px solid #D1D5DB;
  border-radius: 8px;
  overflow: hidden;
  
  &:focus-within {
    border-color: #155DFC;
    box-shadow: 0 0 0 2px rgba(21, 93, 252, 0.1);
  }
`;

export const InlineCategorySelect = styled.div`
  display: inline-flex;
  min-width: 150px;
`;

export const CompactEditorWrapper = styled.div`
  border: 1px solid #D1D5DB;
  border-radius: 8px;
  overflow: hidden;
  
  /* Limit the editor height */
  .tiptap, .ProseMirror, [contenteditable] {
    min-height: 120px;
    max-height: 200px;
    overflow-y: auto;
  }
  
  &:focus-within {
    border-color: #155DFC;
    box-shadow: 0 0 0 2px rgba(21, 93, 252, 0.1);
  }
`;

export const SaveCancelRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 16px 24px;
  border-top: 1px solid #E5E7EB;
  background: #F9FAFB;
  justify-content: flex-end;
`;

/* Skeleton placeholders while note detail is loading */
export const SkeletonBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const SkeletonRow = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const SkeletonSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;
